import SupportRequestDetails from './ui/supportRequestDetails';

export default SupportRequestDetails;
